import { useRouter } from 'next/router';
import { updateRouterQuery } from 'lib/utils/filterUtils';
import { locationNameToQuery, locationNameFromQuery } from 'lib/utils/modelSlugUtils';
import { LocationAutocomplete } from 'components/LocationAutocomplete';
import { GeocodeFeature } from '@mapbox/mapbox-sdk/services/geocoding';
import { encodeBase32, decodeBase32 } from 'geohashing';

interface Props {
  defaultDistance?: number;
}

export const GeoLocationFilter = ({ defaultDistance }: Props) => {
  const router = useRouter();

  const geoLocationToString = (location: Partial<GeocodeFeature>) => {
    const hash = location.center && encodeBase32(location.center[1], location.center[0]);
    const name = locationNameToQuery(location.place_name || '');
    return `${name}~${hash}`;
  };
  const stringToGeoLocation = (location: string): Partial<GeocodeFeature> | undefined => {
    try {
      const [name, hash] = location.split('~');
      const { lat, lng } = decodeBase32(hash);
      const legibleName = locationNameFromQuery(name);
      return { place_name: legibleName, center: [Number(lat), Number(lng)] };
    } catch (err) {
      return undefined;
    }
  };

  const change = (l: Partial<GeocodeFeature> | null) => {
    if (!l) {
      updateRouterQuery(router, { geo: [], distance: [] });
      return;
    }
    updateRouterQuery(router, { geo: geoLocationToString(l) });
  };
  const defaultValue = router.query.geo
    ? stringToGeoLocation(router.query.geo as string)
    : undefined;

  return (
    <LocationAutocomplete
      defaultValue={defaultValue}
      onChange={change}
      label="Location"
      size="small"
      locationTypes={['locality', 'neighborhood', 'place', 'poi', 'poi.landmark', 'postcode']}
      includeDistance
      defaultDistance={defaultDistance}
    />
  );
};
